export default "__VITE_ASSET__566f810f__"